import React, { useRef } from "react"
import Map, { Source, Layer, Marker } from "react-map-gl"
import { MAPBOX_TOKEN, MAP_STYLE } from "../../../constants"
import Pin from "../../../components/Map/Pin"

const areaLayerStyle = {
  id: "arealayer",
  type: "fill",
  source: "area",
  paint: {
    "fill-color": "yellow",
    "fill-opacity": 0.3,
  },
}

export default function AddMarksMap({
  initialCenter,
  marks,
  setMarks,
  activeAreaGeoJson,
}) {
  const mapRef = useRef()

  const handleMapClick = (e) => {
    const coordinates = [e.lngLat.lng, e.lngLat.lat]

    setMarks((prevMarks) => {
      if (!prevMarks || !prevMarks.features) {
        prevMarks = {
          type: "FeatureCollection",
          features: [],
        }
      }

      // Look for an unsaved mark (one without an id)
      const existingIndex = prevMarks.features.findIndex((feature) => !feature.id)

      if (existingIndex !== -1) {
        // Update existing unsaved mark
        const updatedFeatures = prevMarks.features.map((feature, index) => {
          if (index !== existingIndex) return feature

          return {
            ...feature,
            geometry: {
              type: "Point",
              coordinates,
            },
          }
        })

        return {
          ...prevMarks,
          features: updatedFeatures,
        }
      }

      // Create a new unsaved mark
      const newMark = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates,
        },
        properties: {
          name: `Mark ${prevMarks.features.length + 1}`,
        },
      }

      return {
        ...prevMarks,
        features: [...prevMarks.features, newMark],
      }
    })
  }

  // Safely get features
  const markFeatures = marks?.features || []

  return (
    <Map
      initialViewState={{
        latitude: initialCenter.latitude,
        longitude: initialCenter.longitude,
        zoom: 14,
      }}
      mapStyle={MAP_STYLE}
      mapboxAccessToken={MAPBOX_TOKEN}
      style={{ width: "100%", height: "calc(100vh - 300px)" }}
      ref={mapRef}
      onClick={handleMapClick}
    >
      {activeAreaGeoJson?.features?.length > 0 && (
        <Source id="area" type="geojson" data={activeAreaGeoJson}>
          <Layer {...areaLayerStyle} />
        </Source>
      )}
      {markFeatures.map((mark, index) => {
        const coords = mark.geometry?.coordinates
        if (!coords || coords.length !== 2) return null
        
        return (
          <Marker
            key={mark.id || `new-mark-${index}`}
            longitude={coords[0]}
            latitude={coords[1]}
            anchor="bottom"
          >
            <Pin size={20} />
          </Marker>
        )
      })}
    </Map>
  )
}
